const userColors = {
  USER1: '#D486BE',
  USER2: '#B65FAD',
  USER3: '#7D4999',
  USER4: '#176877',
  USER5: '#02A6C5',
  USER6: '#1B987F',
  USER7: '#4FAD70',
}

export default userColors
